import * as dom from "domvm/dist/dev/domvm.dev.js";
export let el = dom.defineElement;
export let sv = dom.defineSvgElement;
export let view = dom.defineView;
export let create = dom.createView;
export let inject = dom.injectView;
export let KEYED_LIST = dom.KEYED_LIST;

export function disableHelp() {
	dom.DEVMODE.mutations = false;
	dom.DEVMODE.warnings = false;
	dom.DEVMODE.verbose = false;
	dom.DEVMODE.UNKEYED_INPUT = false;
}

export type VNode = any;
export interface IDomView{
	redraw();
	mount(el : HTMLElement);
}
export interface IDomRender{
	render(view : IDomView, data: any):VNode;
}
export interface IViewHash {
	[name: string] : IDomRender;
}

export function resizer(handler){
	const resize = (window as any).ResizeObserver;
	const activeHandler = (node) => {

		const height = node.el.offsetHeight;
		const width = node.el.offsetWidth;
		handler(width, height);
	};

	if (resize){
		return el("div.dhx-resize-observer", {
			_hooks:{
				didInsert(node){
					new resize(() => activeHandler(node)).observe(node.el);
				}
			}
		});
	}

	return el("iframe.dhx-resize-observer", {
		_hooks:{
			didInsert(node){
				node.el.contentWindow.onresize = () => activeHandler(node);
				activeHandler(node);
			}
		}
	});
}

export function resizeHandler(container, handler) {
	return create({ render() { return resizer(handler); } }).mount(container);
}

export function awaitRedraw(): Promise<any> {
	return new Promise((res) => {
		requestAnimationFrame(() => {
			res();
		});
	});
}